import { useState } from 'react';
import { useGetContract } from './useGetContract';
import { DEFAULT_GAS_LIMIT, ContractNames, REGISTER_PRICE } from '../constants';
import { getAddress } from '../format';
import { toWei } from '../numbers';
import { increaseByPercent } from '../numbers';
import { useWeb3React } from '@web3-react/core';
import { callNotification } from '../notification';
import { parseErrorToUserReadableMessage } from '../format';
import config from '../config';

export const useRegistration = () => {
  const [isLoadingRegistration, setIsLoadingRegistration] = useState(false);
  const { getContract } = useGetContract();
  const { account } = useWeb3React();

  const registration = async (
    uplineWallet,
    uplineKey = 0,
    uplineId = 0,
    levelsX2 = 1,
    levelsX4 = 0,
    totalPrice = 0,
    minPolly = 0,
    activateIncome = true,
    minPollyX2 = 0,
    minPollyX4 = 0,
  ) => {
    const id = uplineId ? uplineId : 1;
    const refkey = uplineKey ? uplineKey : 0;
    const wallet = uplineWallet ? uplineWallet : '0x1c8a10c304ffaf4267fb2c82a00ab09a3c1cb577';

    if (!isLoadingRegistration) {
      setIsLoadingRegistration(true);

      if (config.stand === 'prod') {
        try {
          const contract = await getContract(ContractNames.ROUTER);

          let gasEstimate = 0;
          if (config.stand === 'prod') {
            gasEstimate = await contract.estimateGas.registrationX2X4V2(
              account,
              wallet,
              id,
              refkey,
              levelsX2,
              levelsX4,
              minPolly,
              activateIncome,
              minPollyX2,
              minPollyX4,
              {
                value: BigInt(totalPrice),
              },
            );
          }

          return await contract.registrationX2X4V2(
            account,
            wallet,
            id,
            refkey,
            levelsX2,
            levelsX4,
            minPolly,
            activateIncome,
            minPollyX2,
            minPollyX4,
            {
              gasLimit: parseInt(gasEstimate) ? increaseByPercent(gasEstimate) : DEFAULT_GAS_LIMIT,
              value: BigInt(totalPrice),
            },
          );
        } catch (e) {
          console.log(e);
          callNotification({ type: 'error', message: parseErrorToUserReadableMessage(e) });
          setIsLoadingRegistration(false);
          return Promise.reject(e);
        } finally {
          setIsLoadingRegistration(false);
        }
      } else {
        try {
          const contract = await getContract(ContractNames.MATRIX_X2X4);
          return await contract.registrationFor(account, wallet);
        } catch (e) {
          console.log(e);
          callNotification({ type: 'error', message: parseErrorToUserReadableMessage(e) });
          setIsLoadingRegistration(false);
          return Promise.reject(e);
        } finally {
          setIsLoadingRegistration(false);
        }
      }
    }
  };

  return {
    registration,
    isLoadingRegistration,
  };
};
